import { Outlet } from 'react-router'
import { StudioAppShell } from './shell/StudioAppShell'

function CommandCenterLayout() {
  return (
    <StudioAppShell commandCenter>
      <Outlet />
    </StudioAppShell>
  )
}

export default CommandCenterLayout
